import React from 'react';
import { Form, AutoSaveInput } from '@blueprintnyc/bpnyc-common';
import { Toggle } from '@blueprintnyc/bpnyc-common-admin';
import ColorInput from 'components/ColorInput';
import WidgetOptionsForm from './WidgetOptionsForm';
import WidgetOptionGroupPermissions from './WidgetOptionGroupPermissions';

const HeaderWidgetOptions = props => {
	const {
		event,
		widgetToUpdate,
		handleChange,
		widgetProps,
		handlePropChange,
		handleGroupChange,
		targetKeys,
	} = props;
	const { headerColor, dividerColor } = widgetProps;

	return (
		<WidgetOptionsForm initialValues={widgetToUpdate.props} handleChange={handleChange}>
			<Form.Item label="Header Text" name="headerText">
				<AutoSaveInput bufferTime={0} />
			</Form.Item>
			<Form.Item label="Header Alignment" name="alignment">
				<Toggle toggleOptions={['left', 'center', 'right']} />
			</Form.Item>
			<Form.Item label="Header Size" name="headerSize">
				<Toggle toggleOptions={['small', 'medium', 'large']} />
			</Form.Item>
			<Form.Item label="Text Color" name="headerColor">
				<ColorInput
					color={headerColor}
					onChange={hex => handlePropChange('headerColor')(hex)}
					eventID={event.id}
				/>
			</Form.Item>
			<Form.Item label="Divider Color" name="dividerColor">
				<ColorInput
					color={dividerColor}
					onChange={hex => handlePropChange('dividerColor')(hex)}
					eventID={event.id}
				/>
			</Form.Item>
			<WidgetOptionGroupPermissions
				event={event}
				handleGroupChange={handleGroupChange}
				targetKeys={targetKeys}
			/>
		</WidgetOptionsForm>
	);
};

export default HeaderWidgetOptions;
